<template>
  <div class="section break-page" style="page-break-inside:avoid">
    <div class="container">
      <div class="title is-1">Detention Rights</div>
      <br />
      <div v-if="questions && questions.length > 0">
        <div class="title is-2">Pre-CTC</div>
        <p>Country: {{ CountryName }}</p>
        <question v-model="questions[0]" @change="change($event, '0')"></question>
        <div v-if="!hidePreCtc">
          <question v-model="questions[1]" v-if="singleOrFleet" @change="change($event, '1')"></question>
          <div class="title is-3" style="margin-top: 30px">Please outline the extent of the detention right.</div>
          <question v-model="questions[2]" @change="change($event, '2')"></question>
          <question v-model="questions[3]" @change="change($event, '3')"></question>
          <question v-model="questions[4]" @change="change($event, '4')"></question>
          <div class="title is-3" style="margin-top: 30px">Please outline any conditions to the validity of, or limitations on, the detention right.</div>
          <question v-model="questions[5]" @change="change($event, '5')"></question>
          <question v-model="questions[6]" @change="change($event, '6')"></question>
          <question v-model="questions[7]" @change="change($event, '7')"></question>
          <question v-model="questions[8]" @change="change($event, '8')"></question>
        </div>
        <div class="title is-2" style="margin-top: 30px">CTC</div>
        <question v-model="questions[9]" @change="change($event, '9')"></question>
        <div v-if="declaration39">
          <question v-model="questions[10]" @change="change($event, '10')"></question>
          <question v-model="questions[11]" @change="change($event, '11')"></question>
        </div>
        <question v-model="questions[12]" @change="change($event, '12')"></question>
        <question v-model="questions[13]" v-if="article40" @change="change($event, '13')"></question>
      </div>
      <br /><br />
      <div v-if="IsClosed && !exporting" class="level">
        <div class="level-left">
          <div class="level-item">
            <b-button class="button is-primary" @click="$router.push('/questionnaire/a/2')">Back</b-button>
          </div>
          <div class="level-item">
            <b-button class="button is-primary" @click="$router.push('/questionnaire/a/4')">Next</b-button>
          </div>
        </div>
      </div>
      <div v-if="!IsClosed && !exporting" class="level">
        <div class="level-left">
          <div class="level-item">
            <b-button class="button is-primary" @click="goToPreviousPage">Save and Back</b-button>
          </div>
          <div class="level-item">
            <b-button class="button is-primary" @click="goToNextPage">Save and Next</b-button>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <b-button class="button is-primary" @click="save">Save</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import sections from "@/enums/sections.ts";
  export default {
    data() {
      return {
        questions: [],
        qpromise: new Promise((resolve, reject) => { })
      }
    },
    props: {
      exporting: Boolean
    },
    methods: {
      async Unlock() {
        await this.$http.get("api/questionnaire/unlock");
        window.addEventListener("beforeunload", this.Unlock);
        return null;
      },
      change(model, prop) {
        this.questions[prop].model = model;
        this.questions.splice();
      },
      goToPreviousPage() {
        this.save().then(() => {
          this.$router.push('/questionnaire/a/2');
        });
      },
      goToNextPage() {
        this.save().then(() => {
          this.$router.push('/questionnaire/a/4');
        });
      },
      async save() {
        return this.$http.post("api/questionnaire/save/" + this.$store.getters["currentQuestionnaire"].Id + "/" + this.$store.getters["user"].Id, this.questions)
          .then(resp => {
            if (this.$store.getters['isAdmin']) {
              this.$parent.saveAdminComment(sections.Detention);
            }
            this.$buefy.notification.open(resp.data);
          }).catch(err => {
            console.error(err);
          });
      }
    },
    created() {
      if (this.$store.getters['isAdmin']) {
        this.$parent.getAdminComment(sections.Detention);
      }

      var Id = -1;
      var groupId = -1;
      if (this.exporting) {
        groupId = this.$parent.options.GroupId;
        Id = this.$parent.options.Id;
      }
      else {
        groupId = this.$store.getters.currentQuestionnaire.GroupId;
        Id = this.$store.getters.currentQuestionnaire.Id;
      }

      this.qpromise =
        this.$http.post("api/questionnaire/questions", {
          SectionId: sections.Detention, GroupId: groupId, QuestionnaireId: Id,
          ignoreLock: this.exporting
        })
          .then(resp => {
            this.questions = resp.data.Questions;
            if (!this.exporting) {
              this.$store.getters.bus.$emit('load-section');
              this.$parent.$parent.lockInfo = { Locker: resp.data.Locker, IsLocker: resp.data.IsLocker, show: true };
            }
          }).catch(err => {
            console.error(err);
          });
      if (!this.exporting)
        window.addEventListener("beforeunload", this.Unlock);
    },
    mounted() {
      var self = this;
      this.qpromise.then(r => {
        self.$store.getters.bus.$emit('loaded', { exporting: self.exporting });
      });
    },
    computed: {
      singleOrFleet() {
        if (this.questions[0].model == 60) {
          return true;
        } else {
          return false;
        }
      },
      hidePreCtc() {
        if (this.questions[0].model == 61) {
          this.questions[1].model = null;
          this.questions[2].model = null;
          this.questions[3].model = null;
          this.questions[4].model = null;
          this.questions[5].model = null;
          this.questions[6].model = null;
          this.questions[7].model = null;
          this.questions[8].model = null;
          return true;
        } else {
          return false;
        }
      },
      article40() {
        if (this.questions[12].model && this.questions[12].model == 119) {
          return true;
        } else {
          this.questions[13].model = null;
          return false;
        }
      },
      declaration39() {
        if (this.questions[9].model && this.questions[9].model == 64) {
          return true;
        } else {
          this.questions[10].model = null;
          this.questions[11].model = null;
          return false;
        }
      },
      IsClosed() {
        if (this.exporting)
          return this.$parent.options.Status == "Closed";
        else
          return this.$store.getters.currentQuestionnaire.Status == "Closed";
      },
      CountryName() {
        if (this.exporting)
          return this.$parent.options.CountryName;
        else
          return this.$store.getters.currentQuestionnaire.CountryName;
      }
    },
    beforeDestroy() {
      if (!this.exporting)
        this.Unlock();
    }
  }
</script>
